/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./tradeChange.vue?vue&type=template&id=50a7afc2&scoped=true&"
import script from "./tradeChange.vue?vue&type=script&lang=js&"
export * from "./tradeChange.vue?vue&type=script&lang=js&"
import style0 from "./tradeChange.vue?vue&type=style&index=0&id=50a7afc2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a7afc2",
  null
  
)

export default component.exports